/* eslint-disable  @typescript-eslint/no-namespace  */

import { createFeatureSelector, createSelector } from "@ngrx/store";

import { SharedState } from "./shared.store";

export namespace SharedSelectors {
  export const partsState =
    createFeatureSelector<SharedState>('SharedState');

  export const filterProfilesAsJson = createSelector(
    partsState,
    (state) => state?.filterProfilesAsJson,
  );
  export const filterProfiles = createSelector(
    partsState,
    (state) => state?.filterProfiles,
  );
  export const postCreateProfile = createSelector(
    partsState,
    (state) => state?.profileCreated,
  );
  export const updateFilterProfile = createSelector(
    partsState,
    (state) => state?.filterModel,
  );
  export const deleteFilter = createSelector(
    partsState,
    (state) => state?.filterId,
  );
  export const sourceTypes = createSelector(
    partsState,
    (state) => state?.sourceTypes,
  );
  export const featureTypes = createSelector(
    partsState,
    (state) => state?.featureTypes,
  );
}
